import { c as _c } from "react/compiler-runtime";
import { isApiError } from '@onefootprint/fetch-hosted';
import { Button, PageShell } from '@onefootprint/ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLogger } from '@/idv2/utils/logger';
import { getErrorKey } from './get-error-key';
const {
  logWarn
} = getLogger({
  name: 'idv2',
  location: 'onboarding-config-error'
});
type OnboardingConfigErrorProps = {
  error: unknown;
  onRetry: () => void;
  isRetrying: boolean;
  onClose?: () => void;
};

/** The config loads before idv2's router exists, so its errors can't reach the route error boundary. */
export const OnboardingConfigError = t0 => {
  const $0 = _c(27);
  const {
    error,
    onRetry,
    isRetrying,
    onClose
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "errorFallback"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($0[1] !== error) {
    t2 = isApiError(error) && error.status === 404 ? "configInvalid" : getErrorKey(error as Error);
    $0[1] = error;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  const errorKey = t2;
  const canRetry = errorKey === "connectionError" || errorKey === "genericError";
  let t3;
  let t4;
  if ($0[3] !== error || $0[4] !== errorKey) {
    t3 = () => {
      logWarn("Onboarding config request failed", error, {
        errorKey
      });
    };
    t4 = [error, errorKey];
    $0[3] = error;
    $0[4] = errorKey;
    $0[5] = t3;
    $0[6] = t4;
  } else {
    t3 = $0[5];
    t4 = $0[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($0[7] !== errorKey) {
    t5 = $ => $[errorKey].title;
    $0[7] = errorKey;
    $0[8] = t5;
  } else {
    t5 = $0[8];
  }
  let t6;
  if ($0[9] !== t || $0[10] !== t5) {
    t6 = t(t5);
    $0[9] = t;
    $0[10] = t5;
    $0[11] = t6;
  } else {
    t6 = $0[11];
  }
  let t7;
  if ($0[12] !== errorKey) {
    t7 = $_0 => $_0[errorKey].subtitle;
    $0[12] = errorKey;
    $0[13] = t7;
  } else {
    t7 = $0[13];
  }
  let t8;
  if ($0[14] !== t || $0[15] !== t7) {
    t8 = t(t7);
    $0[14] = t;
    $0[15] = t7;
    $0[16] = t8;
  } else {
    t8 = $0[16];
  }
  let t9;
  if ($0[17] !== canRetry || $0[18] !== isRetrying || $0[19] !== onClose || $0[20] !== onRetry || $0[21] !== t) {
    t9 = (canRetry || onClose) && <Button onClick={canRetry ? onRetry : onClose} loading={isRetrying} fullWidth={true} size="large" className="mt-6">{canRetry ? t(_temp) : t(_temp2)}</Button>;
    $0[17] = canRetry;
    $0[18] = isRetrying;
    $0[19] = onClose;
    $0[20] = onRetry;
    $0[21] = t;
    $0[22] = t9;
  } else {
    t9 = $0[22];
  }
  let t10;
  if ($0[23] !== t6 || $0[24] !== t8 || $0[25] !== t9) {
    t10 = <PageShell title={t6} subtitle={t8}>{t9}</PageShell>;
    $0[23] = t6;
    $0[24] = t8;
    $0[25] = t9;
    $0[26] = t10;
  } else {
    t10 = $0[26];
  }
  return t10;
};
function _temp($_1) {
  return $_1.tryAgain;
}
function _temp2($_2) {
  return $_2.close;
}